import React from 'react';
import { Tag } from 'antd';
// Helpers
import { StatusMeta } from 'pages/Events/helpers';

type StatusTagProps = {
  meta: StatusMeta;
};

const StatusTag = ({ meta }: StatusTagProps): JSX.Element => (
  <Tag color={meta.color}>{meta.label}</Tag>
);

export default StatusTag;
